import { init as initSentry, browserTracingIntegration } from '@sentry/react';

// rsbuild replaces `process.env.REACT_APP_*` and `process.env.NODE_ENV` with literals at build
// time; `process` itself does not exist at runtime, so it must not be referenced on its own.
const FAKE_SENTRY_DSN = 'FAKE_SENTRY_DSN';
const sentryDsn = process.env.REACT_APP_SENTRY_DSN;

const isSentryEnabled = !!sentryDsn && sentryDsn !== FAKE_SENTRY_DSN;

if (isSentryEnabled) {
  initSentry({
    dsn: sentryDsn,
    environment: process.env.NODE_ENV,
    integrations: [browserTracingIntegration()],
    // Sentry recommends sampling traces
    // https://docs.sentry.io/platforms/javascript/configuration/sampling/#sampling-transaction-events
    tracesSampleRate: 0.5,
  });
}
